import { gql } from "@apollo/client";

export const requestArticle = gql`
  query ShowArticle($id: String!) {
    ShowArticle(article_id: $id) {
      article {
        body
        title
      }
    }
  }
`;
